(() => {
  angular.module('pims').directive('stickyTabs', () => {
    return {
      priority: 1000,
      restrict: 'A',

      link(scope, element) {
        let TAB_MARKER_SELECTOR = '.tabs-marker',
            TAB_CONTAINER_SELECTOR = '#sticky-tab-container',
            NAVBAR_SELECTOR = '.navbar',
            tabsMarker = document.querySelector(TAB_MARKER_SELECTOR),
            tabsContainerEl = document.querySelector(TAB_CONTAINER_SELECTOR),
            navbar = document.querySelector(NAVBAR_SELECTOR);

        function _stickyTabsOnScroll() {
          tabsContainerEl = tabsContainerEl || document.querySelector(TAB_CONTAINER_SELECTOR);
          let tabsTop = tabsMarker.getBoundingClientRect().top,
              navbarBottom = navbar.getBoundingClientRect().bottom;

          if (tabsTop <= navbarBottom) {
            tabsContainerEl.classList.add('sticky-tab-stuck');
          } else if (tabsContainerEl.classList.contains('sticky-tab-stuck')) {
            tabsContainerEl.classList.remove('sticky-tab-stuck');
          }
        }

        const _debounceStickyTabsOnScroll = _.debounce(_stickyTabsOnScroll, 25);

        element.on('scroll', _debounceStickyTabsOnScroll);
        scope.$on('$destroy', () => {
          element.off('scroll');
        });
      }

    };
  });
})();